import { useRef, useState, useEffect } from 'react';
import { Camera, Video, Square, Download, AlertCircle } from 'lucide-react';

export function ScreenshotTool() {
  const [recording, setRecording] = useState(false);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const mediaRef = useRef<MediaRecorder | null>(null);
  const chunksRef = useRef<BlobPart[]>([]);

  // Bug 14: 录屏组件卸载时停止 MediaRecorder
  useEffect(() => {
    return () => {
      if (mediaRef.current && mediaRef.current.state !== 'inactive') {
        mediaRef.current.stop();
      }
    };
  }, []);

  const startRecord = async () => {
    setError(null);
    try {
      const stream = await (navigator as any).mediaDevices.getDisplayMedia({ video: true, audio: false });
      const rec = new MediaRecorder(stream);
      chunksRef.current = [];
      rec.ondataavailable = (e: BlobEvent) => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      rec.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: 'video/webm' });
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        setBlobUrl(URL.createObjectURL(blob));
        stream.getTracks().forEach((t: MediaStreamTrack) => t.stop());
      };
      rec.start();
      mediaRef.current = rec;
      setRecording(true);
    } catch (e: any) {
      setError('需授权屏幕共享；浏览器不支持时请用系统截图快捷键（Win+Shift+S）。');
    }
  };

  const stopRecord = () => {
    mediaRef.current?.stop();
    setRecording(false);
  };

  return (
    <div className="flex flex-col h-full text-white/80 items-center justify-center text-center space-y-6">
      <div className="relative">
        <div className="w-24 h-24 rounded-3xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center shadow-lg">
          <Camera className="text-white" size={40} />
        </div>
        {recording && <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-red-500 animate-pulse" />}
      </div>
      <div>
        <h2 className="text-xl font-black">截图 / 录屏</h2>
        <p className="text-xs text-white/40 max-w-xs mt-1">录制屏幕活动为视频并下载；静态截图请使用系统快捷键（Win+Shift+S）。</p>
      </div>
      {error && <div className="flex items-center gap-2 text-amber-400/80 text-xs"><AlertCircle size={14} />{error}</div>}
      <div className="flex gap-3">
        {!recording ? (
          <button onClick={startRecord} className="flex items-center gap-2 px-5 py-3 rounded-2xl bg-celestial-saturn/20 border border-celestial-saturn/30 text-celestial-saturn font-bold hover:bg-celestial-saturn/30 transition-all">
            <Video size={18} />开始录屏
          </button>
        ) : (
          <button onClick={stopRecord} className="flex items-center gap-2 px-5 py-3 rounded-2xl bg-red-500/20 border border-red-500/40 text-red-300 font-bold hover:bg-red-500/30 transition-all">
            <Square size={18} />停止
          </button>
        )}
      </div>
      {blobUrl && (
        <a href={blobUrl} download={`录屏_${Date.now()}.webm`} className="flex items-center gap-2 px-5 py-3 rounded-2xl bg-white/5 border border-white/10 text-white/70 hover:bg-white/10 transition-all">
          <Download size={18} />下载录像
        </a>
      )}
    </div>
  );
}
